import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MenuComponent } from './menu/menu.component';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { BreadcrumComponent } from './breadcrum/breadcrum.component';
import { FiledragDirective } from './directive/filedrag.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AccessdeniedComponent } from './accessdenied/accessdenied.component';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, MenuComponent, BreadcrumComponent, FiledragDirective, AccessdeniedComponent],
  imports: [
    CommonModule,
    MatListModule,
    MatTabsModule,
    RouterModule,
    MatDialogModule,
    MatMenuModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    BreadcrumComponent,
    FiledragDirective,
    AccessdeniedComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class SharedModule { }
